<template>
  <div class="clearfix" v-if="!pageLoad">
    <div class="spinner-grow text-danger" style="width: 3rem; height: 3rem;margin-top:25vh; margin-left:42%; margin-bottom:5vh" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div v-if="pageLoad" class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 gap-10">
      <div class="position-relative" style="min-width: 220px; max-width: 300px; flex: 1 1 auto;">
        <input
          v-model="searchQuery"
          type="text"
          class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
          placeholder="Rechercher..."
        />
      </div>
      <div class="d-flex align-items-center">
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#companyModal"
          style="background-color: #EB9355;"
          v-if="current_permissions('create_typefee')"
        >
          {{ $t('feeTypes.createFeeType') }}
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </button>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('feeTypes.code') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('feeTypes.name') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('feeTypes.description') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('feeTypes.status') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(typefee) in paginatedTypeFees" :key="typefee.id">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ typefee.code }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ typefee.name }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ typefee.description }}
              </td>
              <td class="shadow-none lh-1 fw-medium">
                <span class="badge text-outline-success" v-if="typefee.status==='ACTIVE'">{{ $t('feeTypes.active') }}</span>
                <span class="badge text-outline-danger" v-if="typefee.status==='INACTIVE'">{{ $t('feeTypes.inactive') }}</span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <div class="dropdown">
                  <button class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);" @click="changeStatus(typefee.status,typefee.code)" v-if="current_permissions('status_typeFee')">
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        <span v-if="typefee.status==='ACTIVE'">{{ $t('feeTypes.deactivate') }}</span>
                        <span v-if="typefee.status==='INACTIVE'">{{ $t('feeTypes.activate') }}</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="filteredTotal>0" class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
        <p v-if="filteredTotal>10" class="mb-0 text-paragraph">
          {{ $t('feeTypes.showing') }} <span class="fw-bold">{{ page*10 }}</span> {{ $t('feeTypes.outOf') }}
          <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('feeTypes.results') }}
        </p>
        <p v-if="filteredTotal<=10" class="mb-0 text-paragraph">
          {{ $t('feeTypes.showing') }} <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('feeTypes.outOf') }}
          <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('feeTypes.results') }}
        </p>
        <nav class="mt-15 mt-md-0">
          <ul class="pagination mb-0">
            <li v-if="(page-1)>0" class="page-item">
              <a class="page-link" @click="goToPage(page-1)" aria-label="Previous">
                <i class="flaticon-chevron-1"></i>
              </a>
            </li>
            <li v-for="(numPage) in numPages" :key="numPage" class="page-item">
              <a v-if="numPage==page" class="page-link active" href="#">{{ numPage }}</a>
              <a v-else class="page-link" @click="goToPage(numPage)">{{ numPage }}</a>
            </li>
            <li v-if="(page+1)<=numPages" class="page-item">
              <a class="page-link" @click="goToPage(page+1)" aria-label="Next">
                <i class="flaticon-chevron"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

  <!-- Modal Create Fee Type -->
  <div class="modal fade" id="companyModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <form @submit.prevent="storeTypeFree">
          <div class="modal-header">
            <h1 class="modal-title fs-5">{{ $t('feeTypes.feeType') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="errors!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>
            </div>
            <div v-if="success!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color:green">{{ success}}</h6>
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="row">
                <div class="col-md-12">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('feeTypes.name') }}</label>
                  <div>
                    <input v-model="formValues.name" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar" :placeholder="$t('feeTypes.namePlaceholder')" @blur="validate('name')" @keyup="validate('name')" :class="{ 'is-invalid': errorsBis['name'] }" />
                    <span class="invalid-feedback">{{ errorsBis['name']}}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('feeTypes.description') }}</label>
                  <div>
                    <textarea v-model="formValues.description" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar" :placeholder="$t('feeTypes.descriptionPlaceholder')" @blur="validate('description')" @keyup="validate('description')" :class="{ 'is-invalid': errorsBis['description'] }">
                    </textarea>
                    <span class="invalid-feedback">{{ errorsBis['description']}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> -->
            <button type="submit" class="btn text-white" style="background-color: #EB9355;" v-if="current_permissions('create_typefee ')">
              <i class="flaticon-plus position-relative ms-5 fs-12" style="color: #FFF;"></i>
              {{ $t('feeTypes.save') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup  lang="ts">
import {ref, onMounted,reactive,inject } from "vue";
import axios from 'axios';
import { useI18n } from "vue-i18n";
import { useTableFilter } from "../../utils/UseTablefilter";
import router from '../../router/index'
import {showToast,checkSessionValidate} from "../../utils/function";
import {current_permissions} from '../../utils/permission';
import { useRouter } from 'vue-router';
import * as yup from 'yup';
const backApi=inject('back');
// const page = ref(1);
// const total = ref(0);
// const pagesLeft = ref(0);
// const currentPage = ref(0);
// const numPages = ref(0);
const { t } = useI18n();


let token: string|null = localStorage.getItem('login_token');

declare interface TypeFree {
  id : string,
  code: string,
  name: string,
  description: string, 
  status:string
  }
 
  const errors = ref('');  
  const success = ref('');
  const errorsBis = {'name':'','description':''};
  const pageLoad = ref(false);

  const formValues = reactive({    
    description: "",  
    name: ""   
  });

  
  const schema = yup.object({    
      description: yup.string().required('La description est requise'),  
      name: yup.string().required('Le nom du pays est requis'),   
     
  });


const typefees =ref(new Array<TypeFree>());
  function formatDateFr(value){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate();  
        day = day<10?'0'+day:day;      
        return day+'/'+month+'/'+year;
        
    }
}

const {
  searchQuery,
  paginatedData: paginatedTypeFees,
  filteredTotal,
  page,
  numPages,
  pageSize,
  showingFrom,
  showingTo,
  goToPage,
} = useTableFilter(
  typefees,
  [
    (t: any) => t.code,
    (t: any) => t.name,
    (t: any) => t.description,
    (t: any) => t.status,
  ],
  15
);
const getTypeFees = (arg=1) =>{
    // +arg
    axios.get(backApi+'/secure/typefees/',{    
      headers: {
            
            Authorization: `Bearer ${token}`
      } 
    })
    .then((response) => {        
        typefees.value = response.data;  //.data.typefees            
        
        // total.value=parseInt(response.data.pagination.total);
        // page.value=parseInt(response.data.pagination.page);
        // pagesLeft.value=parseInt(response.data.pagination.pagesLeft);
        // currentPage.value=parseInt(response.data.pagination.currentPage);
        // numPages.value=parseInt(response.data.pagination.numPages);

        // total.value=10;
        // page.value=1;
        // pagesLeft.value=0;
        // currentPage.value=1;
        // numPages.value=1;
        
        // alert(total.value)
    }).catch((error) => {
          if( error.response){              
              if(error.response.status === 401){
                router.push('/')
                
              }   
              
          }
  });
}

const changeStatus =(status,code)=>{
 // alert(code)
  axios.put(`${backApi}/secure/typefees/${code}/status`,{
          code: code,
          status:  (status=='ACTIVE')?'INACTIVE':'ACTIVE'
        }, {  
      headers: {            
            Authorization: `Bearer ${token}`,
      }       
      }).then((response) => {        
        router.go();        
        
    }).catch((error) => {
          if( error.response){
              //console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                router.push('/')
                
              }   
              
          }
  });
}

const storeTypeFree =()=>{
try {  
  schema.validateSync(formValues);
  axios.post(`${backApi}/secure/typefees/new`,{          
          description:formValues.description,
          name:formValues.name
          
        }, {  
      headers: {            
            Authorization: `Bearer ${token}`,
           'Content-Type':'application/json',
      }       
      }).then((response) => {  
        if(response.status === 200){      
          router.go();  
        }      
        
    }).catch((error) => {
          if( error.response){
              //console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                router.push('/')
                
              }   
              
          }
  });
} catch (error) {
        console.error(error);        
         errors.value="une erreur inattendue est apparue"
      
}

// name:name.value,
// email:email.value,
// contact:contact.value,
// description:description.value
}

function validate(field) {
      schema
        .validateAt(field, formValues)
        .then(() => {
          errorsBis[field] = "";
        })
        .catch(err => {
          errorsBis[field] = err.message;          
        });
        errors.value=''
}


onMounted(() => { 
  checkSessionValidate(1)
  getTypeFees();
   setTimeout(function () {
    pageLoad.value=true; 
         },1000)
});
</script>